"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8424],{

/***/ 45994:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useCheckbox; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41001);
/* harmony import */ var _chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26245);
/* harmony import */ var _chakra_ui_react_use_update_effect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52366);
/* harmony import */ var _chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35155);
/* harmony import */ var _chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81103);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25432);
/* harmony import */ var _chakra_ui_visually_hidden__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5813);
/* harmony import */ var _zag_js_focus_visible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'

// src/use-checkbox.ts
;






// ../../utilities/object-utils/src/omit.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}

// src/use-checkbox.ts



function useCheckbox(props = {}) {
  const formControlProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_1__/* .useFormControlProps */ .K)(props);
  const {
    isDisabled,
    isReadOnly,
    isRequired,
    isInvalid,
    id,
    onBlur,
    onFocus,
    "aria-describedby": ariaDescribedBy
  } = formControlProps;
  const {
    defaultChecked,
    isChecked: checkedProp,
    isFocusable,
    onChange,
    isIndeterminate,
    name,
    value,
    tabIndex = void 0,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-invalid": ariaInvalid,
    ...rest
  } = props;
  const htmlProps = omit(rest, [
    "isDisabled",
    "isReadOnly",
    "isRequired",
    "isInvalid",
    "id",
    "onBlur",
    "onFocus",
    "aria-describedby"
  ]);
  const onChangeProp = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackRef */ .W)(onChange);
  const onBlurProp = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackRef */ .W)(onBlur);
  const onFocusProp = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackRef */ .W)(onFocus);
  const [isFocusVisible, setIsFocusVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isFocused, setFocused] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isHovered, setHovered] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isActive, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    return (0,_zag_js_focus_visible__WEBPACK_IMPORTED_MODULE_3__/* .trackFocusVisible */ .BT)(setIsFocusVisible);
  }, []);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [rootIsLabelElement, setRootIsLabelElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [checkedState, setCheckedState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!defaultChecked);
  const isControlled = checkedProp !== void 0;
  const isChecked = isControlled ? checkedProp : checkedState;
  const handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      if (isReadOnly || isDisabled) {
        event.preventDefault();
        return;
      }
      if (!isControlled) {
        if (isChecked) {
          setCheckedState(event.target.checked);
        } else {
          setCheckedState(isIndeterminate ? true : event.target.checked);
        }
      }
      onChangeProp == null ? void 0 : onChangeProp(event);
    },
    [
      isReadOnly,
      isDisabled,
      isChecked,
      isControlled,
      isIndeterminate,
      onChangeProp
    ]
  );
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_4__/* .useSafeLayoutEffect */ .G)(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(isIndeterminate);
    }
  }, [isIndeterminate]);
  (0,_chakra_ui_react_use_update_effect__WEBPACK_IMPORTED_MODULE_5__/* .useUpdateEffect */ .r)(() => {
    if (isDisabled) {
      setFocused(false);
    }
  }, [isDisabled, setFocused]);
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_4__/* .useSafeLayoutEffect */ .G)(() => {
    const el = inputRef.current;
    if (!(el == null ? void 0 : el.form))
      return;
    const formResetListener = () => {
      setCheckedState(!!defaultChecked);
    };
    el.form.addEventListener("reset", formResetListener);
    return () => {
      var _a;
      return (_a = el.form) == null ? void 0 : _a.removeEventListener("reset", formResetListener);
    };
  }, []);
  const trulyDisabled = isDisabled && !isFocusable;
  const onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      if (event.key === " ") {
        setActive(true);
      }
    },
    [setActive]
  );
  const onKeyUp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      if (event.key === " ") {
        setActive(false);
      }
    },
    [setActive]
  );
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_4__/* .useSafeLayoutEffect */ .G)(() => {
    if (!inputRef.current)
      return;
    const notInSync = inputRef.current.checked !== isChecked;
    if (notInSync) {
      setCheckedState(inputRef.current.checked);
    }
  }, [inputRef.current]);
  const getCheckboxProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, forwardedRef = null) => {
      const onPressDown = (event) => {
        if (isFocused) {
          event.preventDefault();
        }
        setActive(true);
      };
      return {
        ...props2,
        ref: forwardedRef,
        "data-active": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isActive),
        "data-hover": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isHovered),
        "data-checked": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isChecked),
        "data-focus": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isFocused),
        "data-focus-visible": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isFocused && isFocusVisible),
        "data-indeterminate": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isIndeterminate),
        "data-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isDisabled),
        "data-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isInvalid),
        "data-readonly": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isReadOnly),
        "aria-hidden": true,
        onMouseDown: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(props2.onMouseDown, onPressDown),
        onMouseUp: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(props2.onMouseUp, () => setActive(false)),
        onMouseEnter: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(
          props2.onMouseEnter,
          () => setHovered(true)
        ),
        onMouseLeave: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(
          props2.onMouseLeave,
          () => setHovered(false)
        )
      };
    },
    [
      isActive,
      isChecked,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isIndeterminate,
      isInvalid,
      isReadOnly
    ]
  );
  const getIndicatorProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ref: forwardedRef,
      "data-active": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isActive),
      "data-hover": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isHovered),
      "data-checked": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isChecked),
      "data-focus": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isFocused),
      "data-focus-visible": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isFocused && isFocusVisible),
      "data-indeterminate": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isIndeterminate),
      "data-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isDisabled),
      "data-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isInvalid),
      "data-readonly": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isReadOnly)
    }),
    [
      isActive,
      isChecked,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isIndeterminate,
      isInvalid,
      isReadOnly
    ]
  );
  const getRootProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...htmlProps,
      ...props2,
      ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_7__/* .mergeRefs */ .lq)(forwardedRef, (node) => {
        if (!node)
          return;
        setRootIsLabelElement(node.tagName === "LABEL");
      }),
      onClick: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(props2.onClick, () => {
        var _a;
        if (!rootIsLabelElement) {
          (_a = inputRef.current) == null ? void 0 : _a.click();
          requestAnimationFrame(() => {
            var _a2;
            (_a2 = inputRef.current) == null ? void 0 : _a2.focus({ preventScroll: true });
          });
        }
      }),
      "data-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isDisabled),
      "data-checked": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isChecked),
      "data-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isInvalid)
    }),
    [htmlProps, isDisabled, isChecked, isInvalid, rootIsLabelElement]
  );
  const getInputProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, forwardedRef = null) => {
      return {
        ...props2,
        ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_7__/* .mergeRefs */ .lq)(inputRef, forwardedRef),
        type: "checkbox",
        name,
        value,
        id,
        tabIndex,
        onChange: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(props2.onChange, handleChange),
        onBlur: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(
          props2.onBlur,
          onBlurProp,
          () => setFocused(false)
        ),
        onFocus: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(
          props2.onFocus,
          onFocusProp,
          () => setFocused(true)
        ),
        onKeyDown: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(props2.onKeyDown, onKeyDown),
        onKeyUp: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(props2.onKeyUp, onKeyUp),
        required: isRequired,
        checked: isChecked,
        disabled: trulyDisabled,
        readOnly: isReadOnly,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
        "aria-describedby": ariaDescribedBy,
        "aria-disabled": isDisabled,
        style: _chakra_ui_visually_hidden__WEBPACK_IMPORTED_MODULE_8__/* .visuallyHiddenStyle */ .N
      };
    },
    [
      name,
      value,
      id,
      handleChange,
      onBlurProp,
      onFocusProp,
      onKeyDown,
      onKeyUp,
      isRequired,
      isChecked,
      trulyDisabled,
      isReadOnly,
      ariaLabel,
      ariaLabelledBy,
      ariaInvalid,
      isInvalid,
      ariaDescribedBy,
      isDisabled,
      tabIndex
    ]
  );
  const getLabelProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ref: forwardedRef,
      onMouseDown: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAllHandlers */ .v0)(props2.onMouseDown, stopEvent),
      "data-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isDisabled),
      "data-checked": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isChecked),
      "data-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)(isInvalid)
    }),
    [isChecked, isDisabled, isInvalid]
  );
  const state = {
    isInvalid,
    isFocused,
    isChecked,
    isActive,
    isHovered,
    isIndeterminate,
    isDisabled,
    isReadOnly,
    isRequired
  };
  return {
    state,
    getRootProps,
    getCheckboxProps,
    getIndicatorProps,
    getInputProps,
    getLabelProps,
    htmlProps
  };
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}


//# sourceMappingURL=chunk-7D6N5TE5.mjs.map

/***/ }),

/***/ 45966:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/checkbox/dist/chunk-2TOCDA5N.mjs
'use client'

// src/use-initial-animation-state.tsx
;
function useInitialAnimationState(isChecked) {
  const [previousIsChecked, setPreviousIsChecked] = (0,react.useState)(isChecked);
  const [shouldAnimate, setShouldAnimate] = (0,react.useState)(false);
  if (isChecked !== previousIsChecked) {
    setShouldAnimate(true);
    setPreviousIsChecked(isChecked);
  }
  return shouldAnimate;
}


//# sourceMappingURL=chunk-2TOCDA5N.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/chunk-LYGBQ47X.mjs
var chunk_LYGBQ47X = __webpack_require__(44034);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 6 modules
var chunk_ZHQNHOQS = __webpack_require__(22548);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/checkbox/dist/chunk-ULEC7HZU.mjs
'use client'

// src/checkbox-icon.tsx
;

function CheckIcon(props) {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_ZHQNHOQS/* chakra.svg */.m.svg,
    {
      width: "1.2em",
      viewBox: "0 0 12 10",
      style: {
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...props,
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function IndeterminateIcon(props) {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_ZHQNHOQS/* chakra.svg */.m.svg,
    {
      width: "1.2em",
      viewBox: "0 0 24 24",
      style: { stroke: "currentColor", strokeWidth: 4 },
      ...props,
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function CheckboxIcon(props) {
  const { isIndeterminate, isChecked, ...rest } = props;
  const BaseIcon = isIndeterminate ? IndeterminateIcon : CheckIcon;
  return isChecked || isIndeterminate ? /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_ZHQNHOQS/* chakra.div */.m.div,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(BaseIcon, { ...rest })
    }
  ) : null;
}


//# sourceMappingURL=chunk-ULEC7HZU.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/chunk-7D6N5TE5.mjs
var chunk_7D6N5TE5 = __webpack_require__(45994);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var dist = __webpack_require__(25432);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-DMO4EI7P.mjs
var chunk_DMO4EI7P = __webpack_require__(77030);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var styled_system_dist = __webpack_require__(33179);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/checkbox/dist/chunk-CWVAJCXJ.mjs
'use client'
;




// src/checkbox.tsx




var controlStyles = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
};
var rootStyles = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
};
var checkAnim = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
});
var indeterminateOpacityAnim = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var indeterminateScaleAnim = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
});
var Checkbox = (0,chunk_ZJJGQIVY/* forwardRef */.G)(function Checkbox2(props, ref) {
  const group = (0,chunk_LYGBQ47X/* useCheckboxGroupContext */.J)();
  const mergedProps = { ...group, ...props };
  const styles = (0,chunk_DMO4EI7P/* useMultiStyleConfig */.jC)("Checkbox", mergedProps);
  const ownProps = (0,styled_system_dist/* omitThemingProps */.Lr)(props);
  const {
    spacing = "0.5rem",
    className,
    children,
    iconColor,
    iconSize,
    icon = /* @__PURE__ */ (0,jsx_runtime.jsx)(CheckboxIcon, {}),
    isChecked: isCheckedProp,
    isDisabled = group == null ? void 0 : group.isDisabled,
    onChange: onChangeProp,
    inputProps,
    ...rest
  } = ownProps;
  let isChecked = isCheckedProp;
  if ((group == null ? void 0 : group.value) && ownProps.value) {
    isChecked = group.value.includes(ownProps.value);
  }
  let onChange = onChangeProp;
  if ((group == null ? void 0 : group.onChange) && ownProps.value) {
    onChange = (0,dist/* callAll */.PP)(group.onChange, onChangeProp);
  }
  const {
    state,
    getInputProps,
    getCheckboxProps,
    getLabelProps,
    getRootProps
  } = (0,chunk_7D6N5TE5/* useCheckbox */.O)({
    ...rest,
    isDisabled,
    isChecked,
    onChange
  });
  const shouldAnimate = useInitialAnimationState(state.isChecked);
  const iconStyles = (0,react.useMemo)(
    () => ({
      animation: !shouldAnimate ? void 0 : state.isIndeterminate ? `${indeterminateOpacityAnim} 20ms linear, ${indeterminateScaleAnim} 200ms linear` : `${checkAnim} 200ms linear`,
      fontSize: iconSize,
      color: iconColor,
      ...styles.icon
    }),
    [iconColor, iconSize, shouldAnimate, state.isIndeterminate, styles.icon]
  );
  const clonedIcon = (0,react.cloneElement)(icon, {
    __css: iconStyles,
    isIndeterminate: state.isIndeterminate,
    isChecked: state.isChecked
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(
    chunk_ZHQNHOQS/* chakra.label */.m.label,
    {
      __css: { ...rootStyles, ...styles.container },
      className: (0,dist.cx)("chakra-checkbox", className),
      ...getRootProps(),
      children: [
        /* @__PURE__ */ (0,jsx_runtime.jsx)(
          "input",
          {
            className: "chakra-checkbox__input",
            ...getInputProps(inputProps, ref)
          }
        ),
        /* @__PURE__ */ (0,jsx_runtime.jsx)(
          chunk_ZHQNHOQS/* chakra.span */.m.span,
          {
            __css: { ...controlStyles, ...styles.control },
            className: "chakra-checkbox__control",
            ...getCheckboxProps(),
            children: clonedIcon
          }
        ),
        children && /* @__PURE__ */ (0,jsx_runtime.jsx)(
          chunk_ZHQNHOQS/* chakra.span */.m.span,
          {
            className: "chakra-checkbox__label",
            ...getLabelProps(),
            __css: {
              marginStart: spacing,
              ...styles.label
            },
            children
          }
        )
      ]
    }
  );
});
Checkbox.displayName = "Checkbox";


//# sourceMappingURL=chunk-CWVAJCXJ.mjs.map

/***/ }),

/***/ 44034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCheckboxGroupContext; },
/* harmony export */   "z": function() { return /* binding */ CheckboxGroupProvider; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55227);
'use client'

// src/checkbox-context.ts
;
var [CheckboxGroupProvider, useCheckboxGroupContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_0__/* .createContext */ .k)({
  name: "CheckboxGroupContext",
  strict: false
});


//# sourceMappingURL=chunk-LYGBQ47X.mjs.map

/***/ }),

/***/ 41001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useFormControlProps; },
/* harmony export */   "Y": function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var _chunk_OSN4JR34_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38049);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25432);
'use client'
;

// src/use-form-control.ts

function useFormControl(props) {
  const { isDisabled, isInvalid, isReadOnly, isRequired, ...rest } = useFormControlProps(props);
  return {
    ...rest,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    "aria-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .ariaAttr */ .Qm)(isInvalid),
    "aria-required": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .ariaAttr */ .Qm)(isRequired),
    "aria-readonly": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .ariaAttr */ .Qm)(isReadOnly)
  };
}
function useFormControlProps(props) {
  var _a, _b, _c;
  const field = (0,_chunk_OSN4JR34_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useFormControlContext */ .NJ)();
  const {
    id,
    disabled,
    readOnly,
    required,
    isRequired,
    isInvalid,
    isReadOnly,
    isDisabled,
    onFocus,
    onBlur,
    ...rest
  } = props;
  const labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];
  if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) {
    labelIds.push(field.feedbackId);
  }
  if (field == null ? void 0 : field.hasHelpText) {
    labelIds.push(field.helpTextId);
  }
  return {
    ...rest,
    "aria-describedby": labelIds.join(" ") || void 0,
    id: id != null ? id : field == null ? void 0 : field.id,
    isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
    isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
    isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
    isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
    onFocus: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .callAllHandlers */ .v0)(field == null ? void 0 : field.onFocus, onFocus),
    onBlur: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .callAllHandlers */ .v0)(field == null ? void 0 : field.onBlur, onBlur)
  };
}


//# sourceMappingURL=chunk-VLMMX64R.mjs.map

/***/ }),

/***/ 22757:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77030);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25432);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/heading.tsx
;


var Heading = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Heading2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .mq)("Heading", props);
  const { className, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.h2 */ .m.h2,
    {
      ref,
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-heading", props.className),
      ...rest,
      __css: styles
    }
  );
});
Heading.displayName = "Heading";


//# sourceMappingURL=chunk-7OLJDQMT.mjs.map

/***/ }),

/***/ 5813:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ visuallyHiddenStyle; }
/* harmony export */ });
'use client'

// src/visually-hidden.style.ts
var visuallyHiddenStyle = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};


//# sourceMappingURL=chunk-3JHDQ75O.mjs.map

/***/ }),

/***/ 12934:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BT": function() { return /* binding */ trackFocusVisible; }
});

// UNUSED EXPORTS: getInteractionModality, setInteractionModality, trackInteractionModality

;// CONCATENATED MODULE: ./node_modules/@zag-js/dom-query/dist/index.mjs
// src/attrs.ts
var dataAttr = (guard) => {
  return guard ? "" : void 0;
};
var ariaAttr = (guard) => {
  return guard ? "true" : void 0;
};

// src/is-html-element.ts
function isHTMLElement(value) {
  return typeof value === "object" && value?.nodeType === Node.ELEMENT_NODE && typeof value?.nodeName === "string";
}

// src/contains.ts
function contains(parent, child) {
  if (!parent || !child)
    return false;
  if (!isHTMLElement(parent) || !isHTMLElement(child))
    return false;
  return parent === child || parent.contains(child);
}
var isSelfEvent = (event) => contains(event.currentTarget, event.target);

// src/create-scope.ts
var getDocument = (node) => {
  if (node.nodeType === Node.DOCUMENT_NODE)
    return node;
  return node.ownerDocument ?? document;
};
function createScope(methods) {
  const screen = {
    getRootNode: (ctx) => ctx.getRootNode?.() ?? document,
    getDoc: (ctx) => getDocument(screen.getRootNode(ctx)),
    getWin: (ctx) => screen.getDoc(ctx).defaultView ?? window,
    getActiveElement: (ctx) => screen.getDoc(ctx).activeElement,
    getById: (ctx, id) => screen.getRootNode(ctx).getElementById(id)
  };
  return { ...screen, ...methods };
}

// src/env.ts
var isDocument = (el) => el.nodeType === Node.DOCUMENT_NODE;
function getDocument2(el) {
  if (isDocument(el))
    return el;
  return el?.ownerDocument ?? document;
}
function getWindow(el) {
  return el?.ownerDocument.defaultView ?? window;
}

// src/get-active-element.ts
function getActiveElement(el) {
  let activeElement = el.ownerDocument.activeElement;
  while (activeElement?.shadowRoot) {
    const el2 = activeElement.shadowRoot.activeElement;
    if (el2 === activeElement)
      break;
    else
      activeElement = el2;
  }
  return activeElement;
}

// src/get-by-id.ts
function itemById(v, id) {
  return v.find((node) => node.id === id);
}
function indexOfId(v, id) {
  const item = itemById(v, id);
  return item ? v.indexOf(item) : -1;
}
function nextById(v, id, loop = true) {
  let idx = indexOfId(v, id);
  idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
  return v[idx];
}
function prevById(v, id, loop = true) {
  let idx = indexOfId(v, id);
  if (idx === -1)
    return loop ? v[v.length - 1] : null;
  idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
  return v[idx];
}

// src/get-by-text.ts
var getValueText = (item) => item.dataset.valuetext ?? item.textContent ?? "";
var match = (valueText, query2) => valueText.toLowerCase().startsWith(query2.toLowerCase());
var wrap = (v, idx) => {
  return v.map((_, index) => v[(Math.max(idx, 0) + index) % v.length]);
};
function getByText(v, text, currentId) {
  const index = currentId ? indexOfId(v, currentId) : -1;
  let items = currentId ? wrap(v, index) : v;
  const isSingleKey = text.length === 1;
  if (isSingleKey) {
    items = items.filter((item) => item.id !== currentId);
  }
  return items.find((item) => match(getValueText(item), text));
}

// src/get-by-typeahead.ts
function getByTypeaheadImpl(_items, options) {
  const { state, activeId, key, timeout = 350 } = options;
  const search = state.keysSoFar + key;
  const isRepeated = search.length > 1 && Array.from(search).every((char) => char === search[0]);
  const query2 = isRepeated ? search[0] : search;
  let items = _items.slice();
  const next = getByText(items, query2, activeId);
  function cleanup() {
    clearTimeout(state.timer);
    state.timer = -1;
  }
  function update(value) {
    state.keysSoFar = value;
    cleanup();
    if (value !== "") {
      state.timer = +setTimeout(() => {
        update("");
        cleanup();
      }, timeout);
    }
  }
  update(search);
  return next;
}
var getByTypeahead = /* @__PURE__ */ Object.assign(getByTypeaheadImpl, {
  defaultOptions: { keysSoFar: "", timer: -1 },
  isValidEvent: isValidTypeaheadEvent
});
function isValidTypeaheadEvent(event) {
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}

// src/get-computed-style.ts
var styleCache = /* @__PURE__ */ new WeakMap();
function getComputedStyle(el) {
  if (!styleCache.has(el)) {
    const win = el.ownerDocument.defaultView || window;
    styleCache.set(el, win.getComputedStyle(el));
  }
  return styleCache.get(el);
}

// src/get-event-target.ts
function getEventTarget(event) {
  return event.composedPath?.()[0] ?? event.target;
}

// src/get-scroll-parent.ts
function isScrollParent(el) {
  const win = el.ownerDocument.defaultView || window;
  const { overflow, overflowX, overflowY } = win.getComputedStyle(el);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getParent(el) {
  if (el.localName === "html")
    return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if (isHTMLElement(el) && isScrollParent(el)) {
    return el;
  }
  return getScrollParent(getParent(el));
}
function getScrollParents(el, list = []) {
  const parent = getScrollParent(el);
  const isBody = parent === el.ownerDocument.body;
  const win = parent.ownerDocument.defaultView || window;
  const target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(parent) ? parent : []) : parent;
  const parents = list.concat(target);
  return isBody ? parents : parents.concat(getScrollParents(getParent(target)));
}

// src/is-editable-element.ts
function isEditableElement(el) {
  if (el == null || !isHTMLElement(el)) {
    return false;
  }
  try {
    const win = el.ownerDocument.defaultView || window;
    return el instanceof win.HTMLInputElement && el.selectionStart != null || /(textarea|select)/.test(el.localName) || el.isContentEditable;
  } catch {
    return false;
  }
}

// src/platform.ts
var isDom = () => typeof document !== "undefined";
function getPlatform() {
  const agent = navigator.userAgentData;
  return agent?.platform ?? navigator.platform;
}
var pt = (v) => isDom() && v.test(getPlatform());
var ua = (v) => isDom() && v.test(navigator.userAgent);
var vn = (v) => isDom() && v.test(navigator.vendor);
var isTouchDevice = () => isDom() && !!navigator.maxTouchPoints;
var isMac = () => pt(/^Mac/) && !isTouchDevice();
var isIPhone = () => pt(/^iPhone/);
var isSafari = () => isApple() && vn(/apple/i);
var isFirefox = () => ua(/firefox\//i);
var isApple = () => pt(/mac|iphone|ipad|ipod/i);
var isIos = () => isApple() && !isMac();

// src/query.ts
function queryAll(root, selector) {
  return Array.from(root?.querySelectorAll(selector) ?? []);
}
function query(root, selector) {
  return root?.querySelector(selector);
}

// src/raf.ts
function nextTick(fn) {
  const set = /* @__PURE__ */ new Set();
  function raf2(fn2) {
    const id = globalThis.requestAnimationFrame(fn2);
    set.add(() => globalThis.cancelAnimationFrame(id));
  }
  raf2(() => raf2(fn));
  return function cleanup() {
    set.forEach((fn2) => fn2());
  };
}
function raf(fn) {
  const id = globalThis.requestAnimationFrame(fn);
  return () => {
    globalThis.cancelAnimationFrame(id);
  };
}

// src/index.ts
var MAX_Z_INDEX = 2147483647;

//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./node_modules/@zag-js/focus-visible/dist/index.mjs
// src/index.ts

var hasSetup = false;
var modality = null;
var hasEventBeforeFocus = false;
var hasBlurredWindowRecently = false;
var handlers = /* @__PURE__ */ new Set();
function trigger(modality2, event) {
  handlers.forEach((handler) => handler(modality2, event));
}
var dist_isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;
function isValidKey(e) {
  return !(e.metaKey || !dist_isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function onKeyboardEvent(event) {
  hasEventBeforeFocus = true;
  if (isValidKey(event)) {
    modality = "keyboard";
    trigger("keyboard", event);
  }
}
function onPointerEvent(event) {
  modality = "pointer";
  if (event.type === "mousedown" || event.type === "pointerdown") {
    hasEventBeforeFocus = true;
    const target = event.composedPath ? event.composedPath()[0] : event.target;
    let matches = false;
    try {
      matches = target.matches(":focus-visible");
    } catch {
    }
    if (matches)
      return;
    trigger("pointer", event);
  }
}
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted)
    return true;
  return event.detail === 0 && !event.pointerType;
}
function onClickEvent(e) {
  if (isVirtualClick(e)) {
    hasEventBeforeFocus = true;
    modality = "virtual";
  }
}
function onWindowFocus(event) {
  if (event.target === window || event.target === document) {
    return;
  }
  if (!hasEventBeforeFocus && !hasBlurredWindowRecently) {
    modality = "virtual";
    trigger("virtual", event);
  }
  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = false;
}
function onWindowBlur() {
  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = true;
}
function isFocusVisible() {
  return modality !== "pointer";
}
function setupGlobalFocusEvents() {
  if (!isDom() || hasSetup) {
    return;
  }
  const { focus } = HTMLElement.prototype;
  HTMLElement.prototype.focus = function focusElement(...args) {
    hasEventBeforeFocus = true;
    focus.apply(this, args);
  };
  document.addEventListener("keydown", onKeyboardEvent, true);
  document.addEventListener("keyup", onKeyboardEvent, true);
  document.addEventListener("click", onClickEvent, true);
  window.addEventListener("focus", onWindowFocus, true);
  window.addEventListener("blur", onWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    document.addEventListener("pointerdown", onPointerEvent, true);
    document.addEventListener("pointermove", onPointerEvent, true);
    document.addEventListener("pointerup", onPointerEvent, true);
  } else {
    document.addEventListener("mousedown", onPointerEvent, true);
    document.addEventListener("mousemove", onPointerEvent, true);
    document.addEventListener("mouseup", onPointerEvent, true);
  }
  hasSetup = true;
}
function trackFocusVisible(fn) {
  setupGlobalFocusEvents();
  fn(isFocusVisible());
  const handler = () => fn(isFocusVisible());
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}
function trackInteractionModality(fn) {
  setupGlobalFocusEvents();
  fn(modality);
  const handler = () => fn(modality);
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}
function setInteractionModality(value) {
  modality = value;
  trigger(value, null);
}
function getInteractionModality() {
  return modality;
}

//# sourceMappingURL=index.mjs.map

/***/ })

}]);